import { VDataIterator } from 'vuetify/lib/components/VDataIterator';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "d-flex flex-column overflow-hidden"
  }, [_vm.columns.headers && _vm.columns.headers.length && _vm.data.length && !_vm.hideHeader && _vm.size !== 'card' ? _c('uc-rows-headers', {
    staticClass: "mb-2",
    attrs: {
      "font-size": _vm.columns.fontSize,
      "border": _vm.columns.border,
      "headers": _vm.columns.headers,
      "size": _vm.size,
      "can-expand": _vm.columns.canExpand,
      "show-actions": _vm.columns.showActions,
      "can-select": _vm.columns.canSelect
    }
  }) : _vm._e(), _vm.columns.headers && _vm.columns.headers.length && _vm.data.length && !_vm.hideHeader && _vm.size === 'card' ? _c('uc-rows-card-headers', {
    staticClass: "mb-2",
    attrs: {
      "headers": _vm.columns.headers,
      "can-expand": _vm.columns.canExpand,
      "show-actions": _vm.columns.showActions,
      "can-select": _vm.columns.canSelect
    }
  }) : _vm._e(), _c(VDataIterator, {
    ref: "dataIteratorRef",
    class: `uc-rows fill-height ${!_vm.data.length ? 'overflow-hidden no-data' : 'overflow-auto'}`,
    attrs: {
      "items": _vm.data,
      "disable-filtering": true,
      "disable-pagination": true,
      "disable-sort": "",
      "hide-default-footer": ""
    },
    on: {
      "item-selected": function ($event) {
        return _vm.itemSelected($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_vm.totalPages == -1 ? _c('div', [_vm.size === 'card' ? _c('uc-list-row-card-loading') : _c('uc-list-row-loading', {
          attrs: {
            "first-row": true,
            "last-row": true,
            "size": _vm.size,
            "column-defs": _vm.columns
          }
        })], 1) : _vm.$slots['empty-state'] ? _vm._t("empty-state") : _c('div', {
          staticClass: "d-flex fill-width fill-height flex-row align-center justify-center"
        }, [_c('uc-rows-empty-state', {
          attrs: {
            "text": "No Data Found",
            "icon": _vm.GENERIC_EMPTY_STATE
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function ({
        items,
        isExpanded,
        expand,
        isSelected,
        select
      }) {
        return _vm._l(items, function (resource, index) {
          return _c('div', {
            key: `${resource.id}-${index}`
          }, [_c('uc-list-row-resource', _vm._g(_vm._b({
            ref: 'listRow' + index,
            refInFor: true,
            attrs: {
              "id": resource.id,
              "type": resource.type,
              "column-defs": _vm.columns,
              "item": resource,
              "is-expanded": isExpanded,
              "current-expand-state": _vm.localCurrentExpandState,
              "size": _vm.size,
              "is-bulk-select-all": _vm.isLocalBulkSelectAll,
              "is-nested-table": _vm.isNestedTable,
              "is-parent-selected": _vm.isParentSelected
            },
            on: {
              "toggle-select": function ($event) {
                _vm.selectDeselectResource(resource);
                select(resource);
                _vm.emitSelectedResources();
              },
              "row-click": function ($event) {
                return _vm.$emit('row-click', {
                  index,
                  id: resource.id,
                  type: resource.type,
                  details: resource
                });
              },
              "row-dblclick": function ($event) {
                return _vm.$emit('row-dblclick', {
                  index,
                  type: resource.type,
                  id: resource.id,
                  details: resource
                });
              },
              "nested-item-selected": _vm.nestedItemSelected,
              "row:updated": function ($event) {
                return _vm.$emit('row:updated', $event);
              }
            },
            scopedSlots: _vm._u([{
              key: "expand-arrow",
              fn: function () {
                return [resource.props.canExpand ? _c('uc-icon', {
                  class: ['flex-row align-center justify-center mt-1', 'transition3Sec', isExpanded(resource) || _vm.currentExpandState ? 'transformRotate180' : ''],
                  staticStyle: {
                    "height": "30",
                    "width": "30",
                    "overflow": "unset !important"
                  },
                  attrs: {
                    "value": isExpanded(resource) || _vm.currentExpandState ? _vm.DRAWER_CLOSED : _vm.DRAWER_OPENED
                  },
                  on: {
                    "click": function ($event) {
                      expand(resource, !isExpanded(resource));
                    }
                  }
                }) : _vm._e()];
              },
              proxy: true
            }], null, true)
          }, 'uc-list-row-resource', {
            isSelected: isSelected(resource),
            //resource.isSelected,
            ...resource.props,
            firstRow: index === 0,
            lastRow: index === _vm.data.length - 1 && !_vm.hasNextPage,
            additionalData: _vm.additionalData[resource.id],
            backgroundColor: _vm.selectedId === resource.id ? 'layer-active' : 'layer'
          }, false), _vm.listenerObj))], 1);
        });
      }
    }, {
      key: "footer",
      fn: function () {
        return [_vm.hasNextPage && _vm.size !== 'card' ? _c('div', [_c('uc-list-row-loading', {
          attrs: {
            "first-row": false,
            "last-row": false,
            "size": _vm.size,
            "column-defs": _vm.columns
          }
        }), _c('uc-list-row-loading', {
          attrs: {
            "first-row": false,
            "last-row": true,
            "size": _vm.size,
            "column-defs": _vm.columns
          }
        })], 1) : _vm._e(), _vm.hasNextPage && _vm.size === 'card' ? _c('uc-list-row-card-loading') : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localSelectedResources,
      callback: function ($$v) {
        _vm.localSelectedResources = $$v;
      },
      expression: "localSelectedResources"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };